import type { MarketCountryCode } from '@backmarket/http-api'

import { COUNTRIES_WITH_LAST_NAME_FIRST_NAME_ORDER } from '../../constants/name'
import type { Address } from '../../types/address'
/**
 * Combines first name and last name into a full name where order depends on the
 * country code.
 */
export function getFullName(
  countryCode: Address['country'] | MarketCountryCode,
  firstName: Address['firstName'],
  lastName: Address['lastName'],
): string {
  if (!firstName || !lastName) return ''

  const name =
    countryCode &&
    COUNTRIES_WITH_LAST_NAME_FIRST_NAME_ORDER.includes(countryCode)
      ? `${lastName} ${firstName}`
      : `${firstName} ${lastName}`

  return name.trim()
}
